module.exports = __webpack_public_path__ + "img/wupao_c.29d8a585.png";